import React,{Suspense, lazy} from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {CircularProgress,Backdrop,withStyles} from "@material-ui/core";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import { getKontonByid,checkisExpired,getProspektByUserid1,getAktivitetByUserID1, getAFNotis,
  getKontonFlagsById,getNotisByUserid,getAfidLobbySittings,getAfidOrderSittings,getAfidEventSittings,
  getCustomLobby,getDialerAf,switchLanguage,onGetDashBoardValueOf,getuserDialerSetting
  //,setofUpdatedashboardisMessage
 } from 'actions';
import jwtDecode from 'jwt-decode';
import { isEmpty, isUndefined } from 'lodash';
import asyncComponent from "../util/asyncComponent";
import Spinner from './routes/Spinner'
import UpdateSessionToken from './routes/UpdateSessionToken'
import UpdatePassWord from './routes/UpdatePassWord'

import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import Tour from "../components/Tour/index";

import TopNav from "components/TopNav";
import Navigation from "./routes/Navigation";

import CreateWebsocket from './routes/CreateWebsokect'
import {Helmet} from "react-helmet";
import moment from 'moment-timezone'
import Lobby from "./routes/SamplePage/index2"

class App extends React.Component {
  state={
    isExpired:false
  }
  refreshAt(hours, minutes, seconds) {
    var now = new Date();
    var then = new Date();
  
    if(now.getHours() > hours ||
       (now.getHours() == hours && now.getMinutes() > minutes) ||
        now.getHours() == hours && now.getMinutes() == minutes && now.getSeconds() >= seconds) {
        then.setDate(now.getDate() + 1);
    }
    then.setHours(hours);
    then.setMinutes(minutes);
    then.setSeconds(seconds);
		console.log('test')
    var timeout = (then.getTime() - now.getTime());
    // setTimeout(function() { window.location.reload(true); }, timeout);
  }
  intervalID = null
  intervalIDAFNotis = null
  intervalNotis = null
  getmylocale =(lang)=>{
    switch(lang){
      case "SE": return {
        languageId: 'Swedish',
        locale: 'sv',
        name: 'Svenska',
        icon: 'se'
      }
      case "NO": return  {
        languageId: 'Norwegian',
        locale: 'no',
        name: 'Norska',
        icon: 'no'
      }
      case "US": return  {
        languageId: 'English',
        locale: 'en',
        name: 'engelska',
        icon: 'us'
      }
      default: return {
        languageId: 'Swedish',
        locale: 'sv',
        name: 'Svenska',
        icon: 'se'
      }
    }
  }
  componentDidMount=()=>{
    console.log(jwtDecode(this.props.token),"jwtDecode(this.props.token)")
    //user_Lang

    //
    if(parseInt(jwtDecode(this.props.token).user_id) !== 6){
      let locale=this.getmylocale(jwtDecode(this.props.token).user_Lang)
      console.log(locale,"Localeddd222")
			moment.locale(locale.locale)


    this.props.switchLanguage(locale)
    this.props.getKontonByid(jwtDecode(this.props.token).user_Afid,jwtDecode(this.props.token).user_id)
    this.props.getAfidOrderSittings(jwtDecode(this.props.token).user_Afid)
    this.props.getAfidEventSittings(jwtDecode(this.props.token).user_Afid)
    this.props.getAfidLobbySittings(jwtDecode(this.props.token).user_Afid)
    this.props.getDialerAf(jwtDecode(this.props.token).user_Afid)
    this.props.getuserDialerSetting(jwtDecode(this.props.token).user_Afid,jwtDecode(this.props.token).user_id)
    this.props.onGetDashBoardValueOf(jwtDecode(this.props.token).user_Afid,jwtDecode(this.props.token).user_id)
    this.props.getCustomLobby(jwtDecode(this.props.token).user_id,jwtDecode(this.props.token).user_Afid)
     this.intervalID = setInterval(
      () => {
      //  this.refreshAt(23,59,0)
      },
      60000
    );
    //AFNotiser
    this.intervalIDAFNotis = setInterval(
      () => {
        try {
          this.props.getAFNotis(jwtDecode(this.props.token).user_id, jwtDecode(this.props.token).user_Afid, 0, 1,jwtDecode(this.props.token).user_OfficeId)
        } catch {

        }
      },
      180000
    );
    if(jwtDecode(this.props.token).user_id!==6){

      this.props.getNotisByUserid(jwtDecode(this.props.token).user_id)
    this.intervalID = setInterval(() => {
       console.log("getNotisByUserid2")
      this.props.getNotisByUserid(jwtDecode(this.props.token).user_id)
    }, this.props.isExpired?150000:30000);
    }
  }

  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
    clearInterval(this.intervalIDAFNotis);
    clearInterval(this.intervalNotis);
  }
 /* componentDidUpdate=()=>{
    if(this.props.updatedashboardisMessage === 1){
      //this.props.getAFNotis(jwtDecode(this.props.token).user_id, jwtDecode(this.props.token).user_Afid, 0, 1,jwtDecode(this.props.token).user_OfficeId)
      this.props.setofUpdatedashboardisMessage()      
    }
  }*/
  
  
  render() {
    
    if (isEmpty(this.props.currentAccount)) {
      
    }
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
      success,
      authUser,
      token
    } = this.props;

    
    const drawerStyleww = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)

        ? "collapsible-drawer"
        : "mini-drawer";
   
    const PathName = this.props.location.pathname;

    const PageNames = PathName.split('/');
    const PageName = PageNames[PageNames.length - 1]

    if(PageName == "/Prospekt"){
      document.body.classList.add("bg-primary")
    }else{
      document.body.classList.remove("bg-primary")
    }
    return (
      <>

      
      <div className={`app-container ${drawerStyleww} `}>
      
      {/* <Suspense fallback={<div><Spinner/></div>}>
        <Tour />*/}
        
        {
    (isEmpty(this.props.currentAccount) && this.props.authUser.user_id !==6)?
         <Spinner/>
          :
          <>          
        <Sidebar />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
              }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header collapsible-drawer" />
              )}

            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div style={{ overflowX: 'hidden', position: 'relative' }} className="app-main-content">
              {/*
              {
                this.props.authUser.user_Afid === 723812756?"":
              
              <div className="shadow-sm">
                <Navigation 
                PageName={PageName} 
                PathName={PathName} 
                authUser={this.props.authUser} />
              </div>
              }*/}
              {
this.props.NotyLoading === true?
<Spinner/>
:
 
              <Switch>
                
                {
                parseInt(this.props.authUser.user_id) === 6?
                <Route exact
                  path={`${match.url}/Lobby`}
                  component={asyncComponent(() =>
                    import("./routes/konto")
                  )}
                />
                  :
                  parseInt(this.props.authUser.user_role) === 5?
                  <Route exact
                  path={`${match.url}/Lobby`}
                  component={asyncComponent(() =>
                    import("./routes/Order")
                  )}
                  />
                  :
                  <Route exact
                  path={`${match.url}/Lobby`}
                  component={Lobby}
                />
                }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/intranet`}
                  component={Lobby}
                />
                
              }
                {
                   (this.props.authUser.user_id !==6)?"":
                   <Route exact
                   path={`${match.url}/Admin/:idFromAdmin/:userid`}
                   component={Lobby}
                 />   
                }
                
                <Route exact
                  path={`${match.url}/profile/:uid`}
                  component={asyncComponent(() =>
                    import("./routes/UserProfile")
                  )}
                />
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/Offert`}
                  component={asyncComponent(() =>
                    import("./routes/Offert"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Mallmodulen) ===0?"":
                <Route exact
                  path={`${match.url}/V2/Offert`}
                  component={asyncComponent(() =>
                    import("./routes/OffertV2"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/Offert/:offetnamn`}
                  component={asyncComponent(() =>
                    import("./routes/OffertPrev/prevOffert"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/SkapaOffert`}
                  component={asyncComponent(() =>
                    import("./routes/OffertPrev"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/nyanvandare`}
                  component={asyncComponent(() =>
                    import("./routes/nyanvandare"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeAktiviteter) === 1?
                <Route exact
                  path={`${match.url}/Aktiviteter1`}
                  component={asyncComponent(() =>
                    import("./routes/todo2/basic"))}
                />
                :""
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeAktiviteter) === 1?
                <Route exact
                  path={`${match.url}/Aktiviteter`}
                  component={asyncComponent(() =>
                    import("./routes/AktiviteterV2"))}
                />
                :""
              }
              {
                parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeAktiviteter) === 1?
                <Route exact
                  path={`${match.url}/AktiviteterOld`}
                  component={asyncComponent(() =>
                    import("./routes/aktiveter"))}
                />
                :""
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/dela`}
                  component={asyncComponent(() =>
                    import("./routes/dela"))}
                />
                
              }
                {
                  (this.props.authUser.user_id !==6)?"":
                  
                <Route exact
                  path={`${match.url}/ImporterData`}
                  component={asyncComponent(() =>
                    import("./routes/ImporterData"))}
                />}
                {
                  (this.props.authUser.user_id !==6)?"":
                  
                <Route exact
                  path={`${match.url}/Users`}
                  component={asyncComponent(() =>
                    import("./routes/Users"))}
                />}
                {
                  (this.props.authUser.user_id !==6)?"":
                  
                <Route exact
                  path={`${match.url}/SMScenter`}
                  component={asyncComponent(() =>
                    import("./routes/SMScenter"))}
                />}
                {
                  (this.props.authUser.user_id !==6)?"":
                  
                <Route exact
                  path={`${match.url}/LockedUsers`}
                  component={asyncComponent(() =>
                    import("./routes/LockedUsers"))}
                />}
                {
                (this.props.authUser.user_id !==6)?"":
                <Route exact
                  path={`${match.url}/SAMall`}
                  component={asyncComponent(() =>
                    import("./routes/SAMall"))}
                />                    
                }
                
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/mobilaktivitet`}
                  component={asyncComponent(() =>
                    import("./routes/mobilaktivitet"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/popupaktiv`}
                  component={asyncComponent(() =>
                    import("./routes/Popupaktiv"))}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/OffertReact`}
                  component={asyncComponent(() =>
                    import("./routes/OffertReact")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/Konto/Mall/:tempId`}
                  component={asyncComponent(() =>
                    import("./routes/pdfEditor")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/Konto/Mallv2`}
                  component={asyncComponent(() =>
                    import("./routes/DocumentTemplateEditor")
                  )}
                />
              }
              {
                parseInt(this.props.authUser.user_Licans) >=3 ?
                <Route exact
                  path={`${match.url}/search`}
                  component={asyncComponent(() =>
                    import("./routes/SearchActivity")
                  )}
                />
                :""
              }
                {
                  //Dölj Email vyn för essential användare
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/Konto/MailMall`}
                  component={asyncComponent(() =>
                    import("./routes/MailTemplateEditor")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/Dokument`}
                  component={asyncComponent(() =>
                    import("./routes/DocumentPreview")
                  )}
                />
              }
               {/* <Route exact
                  path={`${match.url}/prislista`}
                  component={asyncComponent(() =>
                    import("./routes/Prislista")
                  )}
                />
                <Route exact
                  path={`${match.url}/avtal`}
                  component={asyncComponent(() =>
                    import("./routes/Avtal")
                  )}
                />
                */}
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route exact
                  path={`${match.url}/preview`}
                  component={asyncComponent(() =>
                    import("./routes/Dokument/Prislista/preview")
                  )}
                />
              }
                {
                  (this.props.authUser.user_id !==6)?"":
                <Route exact
                  path={`${match.url}/Konto`}
                  component={asyncComponent(() =>
                    import("./routes/konto")
                  )}
                />
                }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Konto/profile`}
                  component={asyncComponent(() =>
                    import("./routes/konto/Profile")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Konto/Installningar/:Kontoid`}
                  component={asyncComponent(() =>
                    import("./routes/KontoInställningar")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/ChildInstallningar/:Kontoid`}
                  component={asyncComponent(() =>
                    import("./routes/BarnInstallningar")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Konto/Office/:Kontoid`}
                  component={asyncComponent(() =>
                    import("./routes/OfficeSetting")
                  )}
                />
              }

                <Route
                  path={`${match.url}/Kund`}
                  component={asyncComponent(() =>
                   /* (
                      this.props.authUser.user_Afid === 1001
                      ||
                      this.props.authUser.user_Afid === 723812756
                    )?
                    */
                    import("./routes/kundV2")
                    /*:
                    import("./routes/kund")*/
                  )}
                />
                <Route
                  path={`${match.url}/kundV2`}
                  component={asyncComponent(() =>
                    import("./routes/kundV2")
                  )}
                />
                <Route
                  path={`${match.url}/Kunder`}
                  component={asyncComponent(() =>
                 /*   (
                      this.props.authUser.user_Afid === 1001
                      ||
                      this.props.authUser.user_Afid === 723812756
                    )?
                    */
                    import("./routes/KunderV2")
                    /*:
                    import("./routes/Kunder")*/
                  )}
                />
                <Route
                  path={`${match.url}/KunderV2`}
                  component={asyncComponent(() =>
                    import("./routes/KunderV2")
                  )}
                />
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/KedjaOrder`}
                  component={asyncComponent(() =>
                    import("./routes/KedjaOrder")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/KedjaArende`}
                  component={asyncComponent(() =>
                    import("./routes/KedjaArende")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Avtal`}
                  component={asyncComponent(() =>
                    import("./routes/Avtalsvy")
                  )}
                />
              }
                {parseInt(this.props.authUser.user_Licans) === 5?
                  <Route
                  path={`${match.url}/Projekt`}
                  component={asyncComponent(() =>
                    import("./routes/Projektvy")
                  )}
                />
                :
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Projekt) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeProjects) === 1 ?
                <Route
                  path={`${match.url}/Projekt`}
                  component={asyncComponent(() =>
                    import("./routes/Projektvy")
                  )}
                />
                :""
              }
                {
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/ProjektKort`}
                  component={asyncComponent(() =>
                    import("./routes/Projektvy/ProjektKort")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Projektdel`}
                  component={asyncComponent(() =>
                    import("./routes/Projektvy/Tavelvy")
                  )}
                />
              }
                {
                    parseInt(this.props.authUser.user_Licans) === 5?"":                  
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/AvtalsKort`}
                  component={asyncComponent(() =>
                    import("./routes/AvtalsKort")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/ProspektKort`}
                  component={asyncComponent(() =>
                    import("./routes/AvtalsKort")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Prospekt`}
                  component={
                    // (this.props.authUser.user_Afid === 1001 || this.props.authUser.user_Afid === 723812756) ? asyncComponent(() => import("./routes/ProspektV2")) : asyncComponent(() => import("./routes/Prospekt"))}
                    asyncComponent(() => import("./routes/ProspektV2"))}
                />
                
              }
                {/* {
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/ProspektV2`}
                  component={asyncComponent(() =>
                    import("./routes/ProspektV2")
                  )}
                />
              } */}
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/demoAktivititer`}
                  component={asyncComponent(() =>
                    import("./routes/demoaktivititer")
                  )}
                />
                
              }
           
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardPuls`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Puls")
                  )}
                />
                
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.isIamChild) === 2 || parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardBarn`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/BarnKonton")
                  )}
                />
                
              }
             
              {
                //Dashboard - Disable alla vyer (Essential and Ambition)
                parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
              <Route
                  path={`${match.url}/DashboardAnpassad`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Anpassad")
                  )}
                />
                }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardTavling`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Tävling")
                  )}
                />
                }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardTavlingV2`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/TävlingV2")
                  )}
                />
                }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Dashboard`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Individuell")
                  )}
                />
                }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardStart`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/DashboardStart")
                  )}
                />
                }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardSalj`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Sälj")
                  )}
                />
                }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || 
                  (parseInt(this.props.authUser.user_Licans) === 2 && parseInt(this.props.authUser.user_SeeDialer) !== 1 ) 
                  || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardBokning`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Bokning")
                  )}
                />
                }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                
                <Route
                  path={`${match.url}/DashboardPrognos`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Prognos")
                  )}
                />
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
               
                <Route
                  path={`${match.url}/DashboardOrder`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Order")
                  )}
                />
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                
                <Route
                  path={`${match.url}/DashboardProspekt`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Prospekt")
                  )}
                />
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardAktiviteter`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Aktiviteter")
                  )}
                />
                
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/DashboardKontor`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Kontor")
                  )}
                />                
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":                
                <Route
                  path={`${match.url}/Dashboardkonton`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/BarnKonton")
                  )}
                />
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 ||  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                <Route
                  path={`${match.url}/DashboardDialer`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Dialer")
                  )}
                />                
              }
                {
                  //Dashboard - Disable alla vyer (Essential and Ambition)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Projekt) === 0 ?"":
                <Route
                  path={`${match.url}/DashboardProjekt`}
                  component={asyncComponent(() =>
                    import("./routes/DashboardComponentsV2/Projekt")
                  )}
                />                
              }
                <Route
                  path={`${match.url}/SokKund`}
                  component={asyncComponent(() =>
                    import("./routes/SearchVyn")
                  )}
                />
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeEvent) === 1?
               <Route
                  path={`${match.url}/Kalender`}
                  component={asyncComponent(() =>
                    import("./routes/calendar")
                  )}
                />
                :""
                }

                {
                  //Dölj Email vyn för essential användare
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Epost`}
                  component={asyncComponent(() =>
                    import("./routes/mail/basic/indexN")
                  )}
                />                
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5 || 
                  (parseInt(this.props.authUser.user_CanSeeArtReg) === 0 && parseInt(this.props.authUser.user_role) > 2) ?"":
                <Route
                  path={`${match.url}/Artiklar`}
                  component={asyncComponent(() =>
                    import("./routes/Artiklar")
                  )}
                />                
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Friafält`}
                  component={asyncComponent(() =>
                    import("./routes/Friafält")
                  )}
                />                
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/FriafältLogg`}
                  component={asyncComponent(() =>
                    import("./routes/FriafältLogg")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                   parseInt(this.props.authUser.user_role) === 5 || 
                   (parseInt(this.props.authUser.user_CanSeeArtReg) === 0 && parseInt(this.props.authUser.user_role) > 2) ?"":
                <Route
                  path={`${match.url}/Artikelkort/:id`}
                  component={asyncComponent(() =>
                    import("./routes/ArtikelKort")
                  )}
                />
              }
              {
                //Dölj Ordervyn
                parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                parseInt(this.props.authUser.user_SeeOrderList) === 1?
                <Route
                path={`${match.url}/Order`}
                component={asyncComponent(() =>
                  import("./routes/Order")
                )}
              />
              :""
              }
               {
                parseInt(this.props.authUser.user_Licans) === 5?"":
                parseInt(this.props.authUser.user_SeeOrderList) === 1?
                <Route
                  path={`${match.url}/Orderkort`}
                  component={asyncComponent(() =>
                    import("./routes/Orderkort")
                  )}
                />
                :""
                }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Esignering`}
                  component={asyncComponent(() =>
                    import("./routes/Esignering")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/EsigneringKort`}
                  component={asyncComponent(() =>
                    import("./routes/EsigneringKort")
                  )}
                />
              }
                {
                  //Dölj Ndrive Essential and Ambition
                  parseInt(this.props.authUser.user_Licans) === 1 || 
                  parseInt(this.props.authUser.user_Licans) === 2 || 
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_canSeeNDrive) === 1?
                <Route
                  path={`${match.url}/nDrive`}
                  component={asyncComponent(() =>
                    import("./routes/Fil")
                  )}
                />:""
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeEvent) === 1?
                <Route
                  path={`${match.url}/Möte`}
                  component={asyncComponent(() =>
                    import("./routes/Möte")
                  )}
                /> 
                :""
              
              }
               
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeEvent) === 1?
                <Route
                  path={`${match.url}/Moteskort`}
                  component={asyncComponent(() =>
                    import("./routes/Möte/Möteskort")
                  )}
                />
                :""
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Ärende`}
                  component={asyncComponent(() =>
                    import("./routes/Ärende")
                  )}
                />
              }
                {
                  //Dölj Email vyn för essential användare
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeMarketAutomation) === 1?
                <Route
                  path={`${match.url}/Kampanj`}
                  component={asyncComponent(() =>
                    import("./routes/MailCampaigns")
                  )}
                />
                :""
              }
                {
                  //Dölj kunddata för essential användare
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  parseInt(this.props.authUser.user_CanSeeKundData) === 1?
                <Route 
                  path={`${match.url}/Kunddata`}
                  component={asyncComponent(() =>
                    import("./routes/Kunddata")
                  )}
                />
                :""
              }
                {
                  parseInt(this.props.authUser.user_role) === 5 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  (parseInt(this.props.Flags?.ArendePlus)  === 1 ?
                    <Route
                      path={`${match.url}/Ärendekort`}
                      component={asyncComponent(() =>
                        import("./routes/Ärende/ÄrendeKortPlus")
                      )}
                    />
                    : 
                    <Route
                      path={`${match.url}/Ärendekort`}
                      component={asyncComponent(() =>
                        import("./routes/Ärende/Ärendekort")
                      )}
                    />)
              }
                {
                  //Disable "Växla" från profilinställningar (Ambition,Essential)
                  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                <Route
                  path={`${match.url}/Väljkonto`}
                  component={asyncComponent(() =>
                    import("./routes/Väljkonto")
                  )}
                />
              }
               
              
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                  <Route
                  path={`${match.url}/DialerV2`}
                  component={asyncComponent(() =>import("./routes/DialerV2"))}
                /> }
               
                  {/*:*/}
                  {
                    parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                  <Route
                  path={`${match.url}/Dialer`}
                  component={asyncComponent(() =>import("./routes/DialerV2")
                  )}
                />
                
              }
            
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                <Route
                  path={`${match.url}/Dialervy`}
                  component={asyncComponent(() =>
                    import("./routes/Dialer/Dialervy")
                  )}
                />
              }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                <Route
                  path={`${match.url}/Dialervy2`}
                  component={asyncComponent(() =>
                    import("./routes/DialerV2/Dialervy")
                  )}
                />
              }
             
                  {
                    parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                <Route
                  path={`${match.url}/Listvy`}
                  component={asyncComponent(() =>
                    import("./routes/DialerV2/Listvy")
                  )}
                />
                }
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.Dialer) === 0 ?"":
                  parseInt(this.props.authUser.user_SeeDialer)=== 0 ?"":
                <Route
                  path={`${match.url}/Listvy2`}
                  component={asyncComponent(() =>
                    import("./routes/DialerV2/Listvy")
                  )}
                />
                }
                <Route
                  path={`${match.url}/Help`}
                  component={asyncComponent(() =>
                    import("./routes/help")
                  )}
                />
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  <Route
                  path={`${match.url}/Goava`}
                  component={asyncComponent(() =>
                    import("./routes/Goava")
                  )}
                />
                }
                {/* <Route
                  path={`${match.url}/file/:file`}
                  component={asyncComponent(() =>
                    import("./routes/File")
                  )}
                />*/}
                {
                  parseInt(this.props.authUser.user_Licans) === 5?"":
                  parseInt(this.props.authUser.user_role) === 5?"":
                
                <Route
                  path={`${match.url}/NewTabRedirect/:func/:id`}
                  component={asyncComponent(() =>
                    import("./routes/NewTabRedirect")
                  )}
                />
              }
                <Route exact
                  component={asyncComponent(() =>
                    import("components/Error404")
                  )}
                />
              </Switch>
              }
            </div >
            {this.props.authUser.user_id !== 6?
              <CreateWebsocket userid={this.props.authUser.user_id} Afid={this.props.authUser.user_Afid}/>
            :""}
            {/* <Footer /> */}
          </main>
        </div>
 </>}
 {
  isUndefined(localStorage.SPa)?
  parseInt(this.props.authUser.user_Gh) ===1?"":
  parseInt(this.props.authUser.user_passupdate) === 1?<UpdatePassWord/>
  :"":""
 }

 <UpdateSessionToken isExpired={this.props.isExpired}/>
 {
  this.props.authUser.user_Afid === 1001 ||
  this.props.authUser.user_Afid === 723812756?
  <Helmet>
  <style>{`
    df-messenger {
      visibility: visible !important;
    } 
    `}</style>
   </Helmet>  
  :""
 }
 {/*</Suspense> */}
      </div>
      
      </>
    );
  }
}


const mapStateToProps = ({ settings, auth, Avtal, accountsData }) => {
  const { drawerType, navigationStyle, horizontalNavPosition,NotyLoading } = settings;
  const { authUser, token, success,isExpired,isExpireLoadig } = auth;
  
  const { currentAccount,Flags, isIamChild
  //  ,updatedashboardisMessage 
  } = accountsData;
  return {
    drawerType, navigationStyle, horizontalNavPosition, authUser, token, success,
    currentAccount,isExpired,isExpireLoadig,NotyLoading,Flags,isIamChild
    //,updatedashboardisMessage
  };
};
function mapDispatchToProps(dispatch) {
  // { getKontonByid }
  return {
    getNotisByUserid: (userid) => dispatch(getNotisByUserid(userid)),
    getKontonByid: (_kontoid,userid) => dispatch(getKontonByid(_kontoid,userid)),
    getProspektByUserid1: (Afid,Userid,type,ProspektFilterOption) => dispatch(getProspektByUserid1(Afid,Userid,type,ProspektFilterOption)),
    getAktivitetByUserID1: (mainUser,Afid,Filterstate,status,keyword,SearchText,page) => dispatch(getAktivitetByUserID1(mainUser,Afid,Filterstate,status,keyword,SearchText,page)),
    getAFNotis: (Userid, Afid, isDevice, isMessage,isOffice) => dispatch(getAFNotis(Userid, Afid, isDevice, isMessage,isOffice)),
    checkisExpired: (token) => dispatch(checkisExpired(token)),
    //setofUpdatedashboardisMessage: () => dispatch(setofUpdatedashboardisMessage()),
    getAfidLobbySittings: (userid,Afid) => dispatch(getAfidLobbySittings(userid,Afid)),
    getAfidOrderSittings: (userid,Afid) => dispatch(getAfidOrderSittings(userid,Afid)),
    getAfidEventSittings: (Afid) => dispatch(getAfidEventSittings(Afid)),
    getDialerAf: (Afid) => dispatch(getDialerAf(Afid)),
    getuserDialerSetting: (Afid,userid) => dispatch(getuserDialerSetting(Afid,userid)),
    getCustomLobby: (userid,Afid) => dispatch(getCustomLobby(userid,Afid)),
    switchLanguage:(locale) => dispatch(switchLanguage(locale)),
    onGetDashBoardValueOf:(Afid,userid) => dispatch(onGetDashBoardValueOf(Afid,userid))
    //getKontonFlagsById: (Afid) => dispatch(getKontonFlagsById(Afid)),
  }
}
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(App));
